// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdateCalendarEventFooter_wrapper__cvyWz","actionsBtnBlock":"UpdateCalendarEventFooter_actionsBtnBlock__8J483"};